import { useMemo } from 'react';
import { useGetUserCountry } from 'react-easyrocket';
import { EVENT_NAME } from 'src/config/helpers';

import { GameCategoryParams } from 'src/constants/gameCategories';
import { useEvent } from 'src/context/usePromoEvent';

const UNAVAILABLE_AVIATOR_COUNRTY = ['GBR'];

const UNAVAILABLE_DROPSWIN_COUNRTY = ['GBR', 'ROU', 'AUS'];

const AVAILABLE_PRAGMATIC_COUNRTY = [
  'BEL',
  'CHE',
  'NLD',
  'PRT',
  'AUT',
  'DEU',
  'ESP',
  'FIN',
  'IRL',
  'POL',
  'NOR'
];

export function useGameCategories(gameCategories: GameCategoryParams[]) {
  const { eventActive } = useEvent();
  const { userCountry } = useGetUserCountry();
  const country = userCountry?.country;

  const filteredCategories = useMemo(() => {
    if (!country) return [];

    return gameCategories.filter((category) => {
      if (category.path === EVENT_NAME) {
        return eventActive.eventDays;
      }
      if (category.path === 'aviator') {
        return !UNAVAILABLE_AVIATOR_COUNRTY.includes(country);
      }
      if (category.path === 'dropswin') {
        return !UNAVAILABLE_DROPSWIN_COUNRTY.includes(country);
      }
      if (category.path === 'pragmatic-play') {
        return AVAILABLE_PRAGMATIC_COUNRTY.includes(country);
      }
      return true;
    });
  }, [country]);

  return filteredCategories;
}
